module.exports = __webpack_public_path__ + "img/icon-reload-small.2ab12c37.svg";